const jwt_customizer = {
    /** UNTRANSLATED */
    general: 'An error occurred while customizing the JWT token. Please try again later.',
    /** UNTRANSLATED */
    can_not_create_for_admin_tenant: 'Cannot create a JWT token customizer for the admin tenant.',
};
export default Object.freeze(jwt_customizer);
